import api from "./api"; 

const API_URL = "/post"; 

export const postsService = {
  
  async getAllPosts() {
    const res = await api.get(API_URL);
    return res.data;
  },

 
  async getPostById(id) {
    const res = await api.get(`${API_URL}/${id}`);
    return res.data;
  },

 async createPost(formData) {
  const res = await api.post(API_URL, formData);
  return res;
}
,

   
  async updatePost(id, updatedData) {
    const res = await api.put(`${API_URL}/${id}`, updatedData);
    return res.data;
  },

  
  async deletePost(id) {
    const res = await api.delete(`${API_URL}/${id}`);
    return res.data;
  },
  async toggleLike(postId) {
    const response = await api.post(`${API_URL}/${postId}/like`);
    return response.data;
}
};
